import { HttpInterceptorFn } from '@angular/common/http';

export const IFRAME_REQUEST_HEADER = 'x-iframe-request';

export const iframeInterceptor: HttpInterceptorFn = (request, next) => {
    const insideIframe = isInIframe();

    if (!insideIframe) {
        return next(request);
    }

    const newRequest = request.clone({
        setHeaders: {
            [IFRAME_REQUEST_HEADER]: 'true'
        },
    });
    return next(newRequest);
}

// Separate helper function (renamed)
export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    // Cross-origin case → definitely inside iframe
    return true;
  }
}